<template>
    <div>
        <rkm-table
            v-if="!readonly"
            :fields="fields"
            :items="data.model.resultadosExames"
            hide-filters
            hide-pagination
        >
            <template v-slot:cell(exame)="{item}">
                {{`${item.exame.exigeCodigoAb ? item.exame.codigo : formatProcedimento(item.exame.codigo)} - ${item.exame.nome}`}}
            </template>

            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <rkm-area
            :closed="!readonly"
            :no-margin-top="readonly"
            background-color="primary"
            title="Histórico de resultados de exames laboratoriais"
            type="box"
        >
            <rkm-list
                :items="data.form.resultadosExamesLaboratoriais"
                hide-filters
                hide-pagination
            >
                <template v-slot="{item}">
                    <template v-if="item.origem === 'ambulatorio'">
                        <rkm-row>
                            <rkm-col cols="3">
                                <strong>Origem</strong><br />Ambulatório
                            </rkm-col>

                            <rkm-col>
                                <strong>Data / Hora</strong><br />{{item.dataHora}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Setor</strong><br />{{item.centroCusto.setor.nome}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Profissional</strong><br />{{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.nome}}
                            </rkm-col>
                        </rkm-row>

                        <hr />

                        <template v-if="getExamesEco().includes(item.exame.codigo)">
                            <rkm-row>
                                <rkm-col cols="4">
                                    <strong>Exame</strong><br />{{item.exame.exigeCodigoAb ? item.exame.codigo : formatProcedimento(item.exame.codigo)}} - {{item.exame.nome}}
                                </rkm-col>

                                <rkm-col cols="3">
                                    <strong>Idade gestacional em semanas eco</strong><br />{{item.idadeGestacionalSemanasEco}}
                                </rkm-col>

                                <rkm-col cols="3">
                                    <strong>Idade gestacional em dias eco</strong><br />{{item.idadeGestacionalDiasEco}}
                                </rkm-col>

                                <rkm-col cols="2">
                                    <strong>DPP eco</strong><br />{{item.dppEco}}
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col cols="4">
                                    <strong>Data da solicitação</strong><br />{{item.solicitadoEm}}
                                </rkm-col>

                                <rkm-col cols="4">
                                    <strong>Data da realização</strong><br />{{item.realizadoEm}}
                                </rkm-col>

                                <rkm-col cols="4">
                                    <strong>Data do resultado</strong><br />{{item.resultadoEm}}
                                </rkm-col>
                            </rkm-row>
                        </template>

                        <rkm-row v-else>
                            <rkm-col cols="6">
                                <strong>Exame</strong><br />{{item.exame.exigeCodigoAb ? item.exame.codigo : formatProcedimento(item.exame.codigo)}} - {{item.exame.nome}}
                            </rkm-col>

                            <rkm-col cols="2">
                                <strong>Data da solicitação</strong><br />{{item.solicitadoEm}}
                            </rkm-col>

                            <rkm-col cols="2">
                                <strong>Data da realização</strong><br />{{item.realizadoEm}}
                            </rkm-col>

                            <rkm-col cols="2">
                                <strong>Data do resultado</strong><br />{{item.resultadoEm}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="getExamesPercentual().includes(item.exame.codigo)">
                            <rkm-col cols="12">
                                <strong>%</strong><br />{{item.percentual}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="getExamesPuericultura().includes(item.exame.codigo)">
                            <rkm-col cols="12">
                                <strong>Tipo de resultado</strong><br />{{item.resultadoTipoNome}}
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-else-if="item.origem === 'exame-laboratorial'">
                        <rkm-row>
                            <rkm-col cols="3">
                                <strong>Origem</strong><br />Exame laboratorial
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Data / Hora agendada</strong><br />{{item.dataHoraAgendada}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Profissional da coleta</strong><br />{{item.coletaUsuarioNome}} - {{item.coletaOcupacaoNome}}
                            </rkm-col>
                        </rkm-row>
                    </template>
                </template>

                <template v-slot:collapse="{item}">
                    <div class="p-2">
                        <template v-if="item.origem === 'ambulatorio'">
                            <rkm-row>
                                <rkm-col>
                                    {{item.resultado}}
                                </rkm-col>
                            </rkm-row>
                        </template>

                        <template v-else-if="item.origem === 'exame-laboratorial'">
                            <rkm-area title="Exame(s)">
                                <rkm-table
                                    :fields="exameLaboratorialExameFields"
                                    :items="item.exames"
                                    hide-filters
                                    hide-pagination
                                >
                                    <template v-slot:cell(actions)="{ item }">
                                        <rkm-button
                                            v-if="item.dataResultado"
                                            @click="imprimirResultadoExameLaboratorial(item)"
                                            color="primary"
                                            small
                                            title="Imprimir resultado"
                                        >
                                            <rkm-icon icon="print" />
                                        </rkm-button>
                                    </template>
                                </rkm-table>
                            </rkm-area>

                            <rkm-area
                                v-if="item.laudos.length > 0"
                                title="Laudo(s)"
                            >
                                <rkm-table
                                    :fields="exameLaboratorialLaudoFields"
                                    :items="item.laudos"
                                    hide-filters
                                    hide-pagination
                                >
                                    <template v-slot:cell(actions)="{ item }">
                                        <rkm-button
                                            @click="imprimirLaudoExameLaboratorial(item)"
                                            color="primary"
                                            small
                                            title="Imprimir laudo"
                                        >
                                            <rkm-icon icon="print" />
                                        </rkm-button>
                                    </template>
                                </rkm-table>
                            </rkm-area>
                        </template>
                    </div>
                </template>
            </rkm-list>
        </rkm-area>

        <rkm-area
            :closed="!readonly"
            :no-margin-top="readonly"
            background-color="primary"
            title="Histórico de resultados de exames de imagem"
            type="box"
        >
            <rkm-list
                :items="data.form.resultadosExamesImagens"
                hide-filters
                hide-pagination
            >
                <template v-slot="{item}">
                    <template v-if="item.origem === 'ambulatorio'">
                        <rkm-row>
                            <rkm-col cols="3">
                                <strong>Origem</strong><br />Ambulatório
                            </rkm-col>

                            <rkm-col>
                                <strong>Data / Hora</strong><br />{{item.dataHora}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Setor</strong><br />{{item.centroCusto.setor.nome}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Profissional</strong><br />{{item.lotacao.profissional.nome}} - {{item.lotacao.ocupacao.nome}}
                            </rkm-col>
                        </rkm-row>

                        <hr />

                        <template v-if="getExamesEco().includes(item.exame.codigo)">
                            <rkm-row>
                                <rkm-col cols="4">
                                    <strong>Exame</strong><br />{{item.exame.exigeCodigoAb ? item.exame.codigo : formatProcedimento(item.exame.codigo)}} - {{item.exame.nome}}
                                </rkm-col>

                                <rkm-col cols="3">
                                    <strong>Idade gestacional em semanas eco</strong><br />{{item.idadeGestacionalSemanasEco}}
                                </rkm-col>

                                <rkm-col cols="3">
                                    <strong>Idade gestacional em dias eco</strong><br />{{item.idadeGestacionalDiasEco}}
                                </rkm-col>

                                <rkm-col cols="2">
                                    <strong>DPP eco</strong><br />{{item.dppEco}}
                                </rkm-col>
                            </rkm-row>

                            <rkm-row>
                                <rkm-col cols="4">
                                    <strong>Data da solicitação</strong><br />{{item.solicitadoEm}}
                                </rkm-col>

                                <rkm-col cols="4">
                                    <strong>Data da realização</strong><br />{{item.realizadoEm}}
                                </rkm-col>

                                <rkm-col cols="4">
                                    <strong>Data do resultado</strong><br />{{item.resultadoEm}}
                                </rkm-col>
                            </rkm-row>
                        </template>

                        <rkm-row v-else>
                            <rkm-col cols="6">
                                <strong>Exame</strong><br />{{item.exame.exigeCodigoAb ? item.exame.codigo : formatProcedimento(item.exame.codigo)}} - {{item.exame.nome}}
                            </rkm-col>

                            <rkm-col cols="2">
                                <strong>Data da solicitação</strong><br />{{item.solicitadoEm}}
                            </rkm-col>

                            <rkm-col cols="2">
                                <strong>Data da realização</strong><br />{{item.realizadoEm}}
                            </rkm-col>

                            <rkm-col cols="2">
                                <strong>Data do resultado</strong><br />{{item.resultadoEm}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="getExamesPercentual().includes(item.exame.codigo)">
                            <rkm-col cols="12">
                                <strong>%</strong><br />{{item.percentual}}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="getExamesPuericultura().includes(item.exame.codigo)">
                            <rkm-col cols="12">
                                <strong>Tipo de resultado</strong><br />{{item.resultadoTipoNome}}
                            </rkm-col>
                        </rkm-row>
                    </template>

                    <template v-else-if="item.origem === 'exame-imagem'">
                        <rkm-row>
                            <rkm-col cols="3">
                                <strong>Origem</strong><br />Exame de imagem
                            </rkm-col>

                            <rkm-col cols="3">
                                <strong>Data / Hora agendada</strong><br />{{item.dataHoraAgendada}}
                            </rkm-col>

                            <rkm-col>
                                <strong>Profissional executante</strong><br />{{item.usuarioNome}}
                            </rkm-col>
                        </rkm-row>
                    </template>
                </template>

                <template v-slot:collapse="{item}">
                    <div class="p-2">
                        <template v-if="item.origem === 'ambulatorio'">
                            <rkm-row>
                                <rkm-col>
                                    {{item.resultado}}
                                </rkm-col>
                            </rkm-row>
                        </template>

                        <template v-else-if="item.origem === 'exame-imagem'">
                            <rkm-area title="Exame(s)">
                                <rkm-table
                                    :fields="exameImagemExameFields"
                                    :items="item.exames"
                                    hide-filters
                                    hide-pagination
                                >
                                    <template v-slot:cell(actions)="{ item }">
                                        <rkm-button
                                            v-if="item.hasResultado"
                                            @click="imprimirResultadoExameImagem(item)"
                                            color="primary"
                                            small
                                            title="Imprimir resultado"
                                        >
                                            <rkm-icon icon="print" />
                                        </rkm-button>

                                        <rkm-button
                                            v-if="item.hasLaudo"
                                            @click="imprimirLaudoExameImagem(item)"
                                            color="info"
                                            small
                                            title="Imprimir laudo"
                                        >
                                            <rkm-icon icon="print" />
                                        </rkm-button>
                                    </template>
                                </rkm-table>
                            </rkm-area>
                        </template>
                    </div>
                </template>
            </rkm-list>
        </rkm-area>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'

// Mixins.
import {ambulatorioAtendimentoExame, formats, repository, error, file} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {Modal},
    data() {
        return {
            fields: [
                {key: 'exame', label: 'Exame', sortable: true},
                {key: 'solicitadoEm', label: 'Data da solicitação', sortable: true},
                {key: 'realizadoEm', label: 'Data da realização', sortable: true},
                {key: 'resultadoEm', label: 'Data do resultado', sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ],
            exameLaboratorialExameFields: [
                {key: 'exameGrupoNome', label: 'Exame', sortable: true},
                {key: 'dataColeta', label: 'Data da coleta', formatter: v => v ? this.formatDate(v) : null, sortable: true},
                {key: 'dataResultado', label: 'Data do resultado', formatter: v => v ? this.formatDate(v) : null, sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ],
            exameLaboratorialLaudoFields: [
                {key: 'arquivo', label: 'Laudo', sortable: true},
                {key: 'data', label: 'Data', formatter: v => this.formatDate(v), sortable: true},
                {key: 'responsavel', label: 'Responsável', sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ],
            exameImagemExameFields: [
                {key: 'exameNome', label: 'Exame', sortable: true},
                {key: 'dataHoraResultadoLaudo', label: 'Data/hora do resultado/laudo', formatter: v => this.formatDateTime(v), sortable: true},
                {class: 'col-min text-center', key: 'actions', label: 'Ações'},
            ],
        }
    },
    created() {
        this.repositories = {
            impressaoExameLaboratorial: this.getConectaSusRepository('impressao.exameLaboratorial'),
            laudoExameLaboratorial: this.getConectaSusRepository('exameLaboratorial.importarLaudo'),
            impressaoExameImagem: this.getConectaSusRepository('impressao.exameImagem'),
            lancamentoExameImagem: this.getConectaSusRepository('exameImagem.lancamento'),
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        imprimirResultadoExameLaboratorial(item) {
            this.setLoading()

            this.repositories.impressaoExameLaboratorial.exame({
                agendamento_id: item.agendamentoId,
                pertence_grupo: item.pertenceGrupo,
                exame_grupo_id: item.exameGrupoId,
                mapa_agrupado: item.mapaAgrupado,
                assinatura_profissional_id: item.assinaturaProfissionalId,
            })
                .then(response => this.openFile(response.data, response.headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        imprimirLaudoExameLaboratorial(item) {
            if (item.url) {
                window.open(item.url, '_blank')

                return
            }

            this.setLoading()

            this.repositories.laudoExameLaboratorial.download(item.id)
                .then(response => this.openFile(response.data, response.headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        imprimirResultadoExameImagem(item) {
            this.setLoading()

            this.repositories.impressaoExameImagem.lancamento(item.agendamentoExameId)
                .then(response => this.openFile(response.data, response.headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        imprimirLaudoExameImagem(item) {
            this.setLoading()

            this.repositories.lancamentoExameImagem.download(item.agendamentoExameId)
                .then(response => this.openFile(response.data, response.headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o resultado de exame?', async () => {
                this.data.model.resultadosExames.splice(index, 1)
            })
        },
    },
    mixins: [ambulatorioAtendimentoExame, formats, repository, error, file],
    props: {
        data: {type: Object, required: true},
        readonly: {type: Boolean, required: true},
    },
}
</script>